import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { Box, Grid, IconButton } from "@mui/material"; 
import BatchConclutionModal from './../BatchConclutionModal/BatchConclutionModal';

const BatchConclutionRoutine = ({ routine }) => {
  const { Subject, Chapter } = routine;
  //   const theme = useTheme();
  const [openRoutine, setOpenRoutine] = React.useState(false);
  const handleRoutineOpen = () => setOpenRoutine(true);
  const handleRoutineClose = () => setOpenRoutine(false);
  return (
    <>
      <Grid item xs={11} md={4} sm={6}>
        <Card
          sx={{
            display: "flex",
            justifyContent: "space-around",
            textAlign: "center",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CardContent sx={{ flex: "1 0 auto" }}>
              <Typography component="div" variant="h5">
                {Chapter}
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                component="div"
              >
                {Subject}
              </Typography>
            </CardContent>
          </Box>
          <CardActions>
            <IconButton
              onClick={handleRoutineOpen}
              aria-label="watch"
              size="large"
            >
              <VisibilityRoundedIcon
                sx={{
                  "&:hover": {
                    padding: "14px",
                    borderRadius: "50%",
                  },
                }}
                fontSize="inherit"
              />
            </IconButton>
          </CardActions>
        </Card>
      </Grid>
      <BatchConclutionModal
        routine={routine}
        handleRoutineClose={handleRoutineClose}
        openRoutine={openRoutine}
      ></BatchConclutionModal>
    </>
  );
};

export default BatchConclutionRoutine;
